'use strict';

angular.module('licensure.services')
    .factory('EnterprisePublicLookup', ['$http', '$q', function ($http, $q) {
        return {
            get: function (args) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/enterprisepubliclookup', {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getEducationReportLookupPermission: function (userId) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/EducationModule/EducationReportLookupPermission/" + userId, {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },
        }
    }])
    ;